module.exports = __webpack_public_path__ + "static/media/SearchIcon.34bd5247.svg";